// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  AbortOralExamHeaders,
  AcknowledgeOralExamConductHeaders,
  AdvanceOralExamQuestionBody,
  AdvanceOralExamQuestionHeaders,
  ApproveOralExamIdVerificationHeaders,
  BroadcastOralExamCohortMessageHeaders,
  CancelOralExamBookingAllowRebookingHeaders,
  CancelOralExamTechnicalHeaders,
  CloseOralExamCohortBody,
  CloseOralExamCohortHeaders,
  CloseOralExamWrapUpHeaders,
  CompleteOralExamIfAbsentHeaders,
  EndOralExamHeaders,
  GenericApiResponseDict,
  GenericApiResponseDictStrBool,
  GenericApiResponseIdPhotoUrlResponse,
  GenericApiResponseOralExamAgentControlStateResponse,
  GenericApiResponseOralExamAggregateTimeSlotStateResponse,
  GenericApiResponseOralExamLoungeResponse,
  GenericApiResponseOralExamPracticeAvailabilityResponse,
  GenericApiResponseOralExamPracticeEnsureResponse,
  GenericApiResponseOralExamRunStateResponse,
  GenericApiResponseOralExamTimeSlotStateResponse,
  GenericApiResponseOralExamTokenResponse,
  GenericApiResponseSupervisorPhotoUrlResponse,
  GetOralExamAgentControlStateParams,
  GetOralExamIdPhotoUrlParams,
  GetOralExamPracticeParams,
  GetOralExamSessionAgentControlStateParams,
  GetSupervisorPhotoUrlParams,
  HTTPValidationError,
  MarkOralExamOrientationCompletedHeaders,
  MarkOralExamPreflightLobbyReadyHeaders,
  MarkOralExamStudentReadyHeaders,
  OpenOralExamAnswerWindowHeaders,
  OpenOralExamGroupBriefingHeaders,
  OralExamAcknowledgeConductRequest,
  OralExamAgentFailoverRequest,
  OralExamBroadcastMessageRequest,
  OralExamDropInHeaders,
  OralExamDropInRequest,
  OralExamPauseRequest,
  OralExamPracticeEnsureRequest,
  OralExamRecordConsentRequest,
  OralExamRejectIdVerificationRequest,
  OralExamStartTimeSlotRequest,
  OralExamSubmitIdentityPhotosRequest,
  OralExamTransitionPhaseRequest,
  OralExamUploadSupervisorPhotoRequest,
  PauseOralExamHeaders,
  RecordOralExamConsentHeaders,
  RedrawOralExamQuestionsHeaders,
  RejectOralExamIdVerificationHeaders,
  RepeatOralExamPreviousQuestionBody,
  RepeatOralExamPreviousQuestionHeaders,
  ReportOralExamMediaDisabledBody,
  ReportOralExamMediaDisabledHeaders,
  ReportOralExamMediaEnabledBody,
  ReportOralExamMediaEnabledHeaders,
  RequestOralExamHelpHeaders,
  ResetOralExamHeaders,
  ResetOralExamTimerBody,
  ResetOralExamTimerHeaders,
  SignalOralExamStudentDoneBody,
  SignalOralExamStudentDoneHeaders,
  StartOralExamCohortHeaders,
  StartOralExamHeaders,
  StartOralExamSelfServiceSessionHeaders,
  SubmitOralExamBookingForEvaluationHeaders,
  SubmitOralExamIdentityPhotosHeaders,
  TransitionOralExamSessionPhaseHeaders,
} from '../../models';

/**
 * Return whether the student can start a practice exam for this oral-exam task.
 * @summary Get Oral Exam Practice
 */
export const getOralExamPractice = (
  params: GetOralExamPracticeParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamPracticeAvailabilityResponse>> => {
  return axios.get(`/oral-exams/practice`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetOralExamPracticeQueryKey = (params: GetOralExamPracticeParams) => {
  return [`/oral-exams/practice`, ...(params ? [params] : [])] as const;
};

export const getGetOralExamPracticeQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetOralExamPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamPracticeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamPractice>>> = ({ signal }) =>
    getOralExamPractice(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOralExamPractice>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOralExamPracticeQueryResult = NonNullable<Awaited<ReturnType<typeof getOralExamPractice>>>;
export type GetOralExamPracticeQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamPractice<
  TData = Awaited<ReturnType<typeof getOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetOralExamPracticeParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamPractice<
  TData = Awaited<ReturnType<typeof getOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetOralExamPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamPractice<
  TData = Awaited<ReturnType<typeof getOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetOralExamPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Oral Exam Practice
 */

export function useGetOralExamPractice<
  TData = Awaited<ReturnType<typeof getOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: GetOralExamPracticeParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamPractice>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamPracticeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or reuse the student's practice slot and booking for this task.
 * @summary Ensure Oral Exam Practice
 */
export const ensureOralExamPractice = (
  oralExamPracticeEnsureRequest: OralExamPracticeEnsureRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamPracticeEnsureResponse>> => {
  return axios.post(`/oral-exams/practice/ensure`, oralExamPracticeEnsureRequest, options);
};

export const getEnsureOralExamPracticeMutationOptions = <
  TData = Awaited<ReturnType<typeof ensureOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: OralExamPracticeEnsureRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['ensureOralExamPractice'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ensureOralExamPractice>>,
    { data: OralExamPracticeEnsureRequest }
  > = (props) => {
    const { data } = props ?? {};

    return ensureOralExamPractice(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: OralExamPracticeEnsureRequest },
    TContext
  >;
};

export type EnsureOralExamPracticeMutationResult = NonNullable<Awaited<ReturnType<typeof ensureOralExamPractice>>>;
export type EnsureOralExamPracticeMutationBody = OralExamPracticeEnsureRequest;
export type EnsureOralExamPracticeMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Ensure Oral Exam Practice
 */
export const useEnsureOralExamPractice = <
  TData = Awaited<ReturnType<typeof ensureOralExamPractice>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: OralExamPracticeEnsureRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: OralExamPracticeEnsureRequest }, TContext> => {
  const mutationOptions = getEnsureOralExamPracticeMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Mint a short-lived video meeting join token for the authenticated booking participant.
 * @summary Issue Oral Exam Join Token
 */
export const issueOralExamJoinToken = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTokenResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/join-token`,
    undefined,
    options,
  );
};

export const getIssueOralExamJoinTokenMutationOptions = <
  TData = Awaited<ReturnType<typeof issueOralExamJoinToken>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['issueOralExamJoinToken'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof issueOralExamJoinToken>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId } = props ?? {};

    return issueOralExamJoinToken(courseId, moduleId, taskId, bookingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
};

export type IssueOralExamJoinTokenMutationResult = NonNullable<Awaited<ReturnType<typeof issueOralExamJoinToken>>>;

export type IssueOralExamJoinTokenMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Issue Oral Exam Join Token
 */
export const useIssueOralExamJoinToken = <
  TData = Awaited<ReturnType<typeof issueOralExamJoinToken>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string },
  TContext
> => {
  const mutationOptions = getIssueOralExamJoinTokenMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Mint a short-lived video meeting join token for the slot lecturer (no booking required).
 * @summary Issue Oral Exam Lecturer Join Token
 */
export const issueOralExamLecturerJoinToken = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTokenResponse>> => {
  return axios.post(`/slots/${slotId}/join-token`, undefined, options);
};

export const getIssueOralExamLecturerJoinTokenMutationOptions = <
  TData = Awaited<ReturnType<typeof issueOralExamLecturerJoinToken>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['issueOralExamLecturerJoinToken'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof issueOralExamLecturerJoinToken>>, { slotId: string }> = (
    props,
  ) => {
    const { slotId } = props ?? {};

    return issueOralExamLecturerJoinToken(slotId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { slotId: string }, TContext>;
};

export type IssueOralExamLecturerJoinTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof issueOralExamLecturerJoinToken>>
>;

export type IssueOralExamLecturerJoinTokenMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Issue Oral Exam Lecturer Join Token
 */
export const useIssueOralExamLecturerJoinToken = <
  TData = Awaited<ReturnType<typeof issueOralExamLecturerJoinToken>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string }, TContext> => {
  const mutationOptions = getIssueOralExamLecturerJoinTokenMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Return current oral exam run state for lecturer or student polling.
 * @summary Get Session State State
 */
export const getOralExamRunState = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/state`, options);
};

export const getGetOralExamRunStateQueryKey = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/state`] as const;
};

export const getGetOralExamRunStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamRunState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamRunStateQueryKey(courseId, moduleId, taskId, bookingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamRunState>>> = ({ signal }) =>
    getOralExamRunState(courseId, moduleId, taskId, bookingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(courseId && moduleId && taskId && bookingId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetOralExamRunStateQueryResult = NonNullable<Awaited<ReturnType<typeof getOralExamRunState>>>;
export type GetOralExamRunStateQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamRunState<
  TData = Awaited<ReturnType<typeof getOralExamRunState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamRunState<
  TData = Awaited<ReturnType<typeof getOralExamRunState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamRunState<
  TData = Awaited<ReturnType<typeof getOralExamRunState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Session State State
 */

export function useGetOralExamRunState<
  TData = Awaited<ReturnType<typeof getOralExamRunState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamRunState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamRunStateQueryOptions(courseId, moduleId, taskId, bookingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return a short-lived SAS URL for a supervisor's account profile photo.
 * @summary Get Supervisor Photo Url
 */
export const getSupervisorPhotoUrl = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params?: GetSupervisorPhotoUrlParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseSupervisorPhotoUrlResponse>> => {
  return axios.get(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/supervisor-photo-url`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getGetSupervisorPhotoUrlQueryKey = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params?: GetSupervisorPhotoUrlParams,
) => {
  return [
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/supervisor-photo-url`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSupervisorPhotoUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getSupervisorPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params?: GetSupervisorPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSupervisorPhotoUrlQueryKey(courseId, moduleId, taskId, bookingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>> = ({ signal }) =>
    getSupervisorPhotoUrl(courseId, moduleId, taskId, bookingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(courseId && moduleId && taskId && bookingId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetSupervisorPhotoUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>>;
export type GetSupervisorPhotoUrlQueryError = AxiosError<void | HTTPValidationError>;

export function useGetSupervisorPhotoUrl<
  TData = Awaited<ReturnType<typeof getSupervisorPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params: undefined | GetSupervisorPhotoUrlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSupervisorPhotoUrl<
  TData = Awaited<ReturnType<typeof getSupervisorPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params?: GetSupervisorPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSupervisorPhotoUrl<
  TData = Awaited<ReturnType<typeof getSupervisorPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params?: GetSupervisorPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Supervisor Photo Url
 */

export function useGetSupervisorPhotoUrl<
  TData = Awaited<ReturnType<typeof getSupervisorPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  params?: GetSupervisorPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSupervisorPhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSupervisorPhotoUrlQueryOptions(courseId, moduleId, taskId, bookingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return waiting-lounge hints and optional tenant media SAS URLs for this booking.
 * @summary Get Oral Exam Lounge
 */
export const getOralExamLounge = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamLoungeResponse>> => {
  return axios.get(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/lounge`, options);
};

export const getGetOralExamLoungeQueryKey = (courseId: string, moduleId: string, taskId: string, bookingId: string) => {
  return [`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/lounge`] as const;
};

export const getGetOralExamLoungeQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamLounge>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamLoungeQueryKey(courseId, moduleId, taskId, bookingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamLounge>>> = ({ signal }) =>
    getOralExamLounge(courseId, moduleId, taskId, bookingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(courseId && moduleId && taskId && bookingId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetOralExamLoungeQueryResult = NonNullable<Awaited<ReturnType<typeof getOralExamLounge>>>;
export type GetOralExamLoungeQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamLounge<
  TData = Awaited<ReturnType<typeof getOralExamLounge>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamLounge<
  TData = Awaited<ReturnType<typeof getOralExamLounge>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamLounge<
  TData = Awaited<ReturnType<typeof getOralExamLounge>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Oral Exam Lounge
 */

export function useGetOralExamLounge<
  TData = Awaited<ReturnType<typeof getOralExamLounge>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamLounge>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamLoungeQueryOptions(courseId, moduleId, taskId, bookingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Return a short-lived SAS URL for the student's uploaded ID photo (lecturer review).
 * @summary Get Oral Exam Id Photo Url
 */
export const getOralExamIdPhotoUrl = (
  slotId: string,
  bookingId: string,
  params?: GetOralExamIdPhotoUrlParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseIdPhotoUrlResponse>> => {
  return axios.get(`/slots/${slotId}/bookings/${bookingId}/id-photo-url`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetOralExamIdPhotoUrlQueryKey = (
  slotId: string,
  bookingId: string,
  params?: GetOralExamIdPhotoUrlParams,
) => {
  return [`/slots/${slotId}/bookings/${bookingId}/id-photo-url`, ...(params ? [params] : [])] as const;
};

export const getGetOralExamIdPhotoUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  bookingId: string,
  params?: GetOralExamIdPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamIdPhotoUrlQueryKey(slotId, bookingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>> = ({ signal }) =>
    getOralExamIdPhotoUrl(slotId, bookingId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!(slotId && bookingId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOralExamIdPhotoUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>>;
export type GetOralExamIdPhotoUrlQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamIdPhotoUrl<
  TData = Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  bookingId: string,
  params: undefined | GetOralExamIdPhotoUrlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamIdPhotoUrl<
  TData = Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  bookingId: string,
  params?: GetOralExamIdPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamIdPhotoUrl<
  TData = Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  bookingId: string,
  params?: GetOralExamIdPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Oral Exam Id Photo Url
 */

export function useGetOralExamIdPhotoUrl<
  TData = Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  bookingId: string,
  params?: GetOralExamIdPhotoUrlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamIdPhotoUrl>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamIdPhotoUrlQueryOptions(slotId, bookingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lock question selection and transition the run to in_progress.
 * @summary Start Oral Exam
 */
export const startOralExam = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: StartOralExamHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/start`, undefined, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getStartOralExamMutationOptions = <
  TData = Awaited<ReturnType<typeof startOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: StartOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['startOralExam'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startOralExam>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: StartOralExamHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return startOralExam(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: StartOralExamHeaders },
    TContext
  >;
};

export type StartOralExamMutationResult = NonNullable<Awaited<ReturnType<typeof startOralExam>>>;

export type StartOralExamMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Start Oral Exam
 */
export const useStartOralExam = <
  TData = Awaited<ReturnType<typeof startOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: StartOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: StartOralExamHeaders },
  TContext
> => {
  const mutationOptions = getStartOralExamMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student-owned start for self-service exams (practice). Skips group briefing.
 * @summary Start Oral Exam Self Service Session
 */
export const startOralExamSelfServiceSession = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: StartOralExamSelfServiceSessionHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/start-session`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getStartOralExamSelfServiceSessionMutationOptions = <
  TData = Awaited<ReturnType<typeof startOralExamSelfServiceSession>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: StartOralExamSelfServiceSessionHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['startOralExamSelfServiceSession'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startOralExamSelfServiceSession>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: StartOralExamSelfServiceSessionHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return startOralExamSelfServiceSession(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: StartOralExamSelfServiceSessionHeaders;
    },
    TContext
  >;
};

export type StartOralExamSelfServiceSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof startOralExamSelfServiceSession>>
>;

export type StartOralExamSelfServiceSessionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Start Oral Exam Self Service Session
 */
export const useStartOralExamSelfServiceSession = <
  TData = Awaited<ReturnType<typeof startOralExamSelfServiceSession>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: StartOralExamSelfServiceSessionHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    headers?: StartOralExamSelfServiceSessionHeaders;
  },
  TContext
> => {
  const mutationOptions = getStartOralExamSelfServiceSessionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Re-roll the pre-start draft question selection.
 * @summary Redraw Oral Exam Questions
 */
export const redrawOralExamQuestions = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: RedrawOralExamQuestionsHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/redraw-questions`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getRedrawOralExamQuestionsMutationOptions = <
  TData = Awaited<ReturnType<typeof redrawOralExamQuestions>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RedrawOralExamQuestionsHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['redrawOralExamQuestions'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redrawOralExamQuestions>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RedrawOralExamQuestionsHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return redrawOralExamQuestions(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RedrawOralExamQuestionsHeaders },
    TContext
  >;
};

export type RedrawOralExamQuestionsMutationResult = NonNullable<Awaited<ReturnType<typeof redrawOralExamQuestions>>>;

export type RedrawOralExamQuestionsMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Redraw Oral Exam Questions
 */
export const useRedrawOralExamQuestions = <
  TData = Awaited<ReturnType<typeof redrawOralExamQuestions>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RedrawOralExamQuestionsHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RedrawOralExamQuestionsHeaders },
  TContext
> => {
  const mutationOptions = getRedrawOralExamQuestionsMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Advance to the next question while the exam is in progress.
 * @summary Advance Oral Exam Question
 */
export const advanceOralExamQuestion = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  advanceOralExamQuestionBody: AdvanceOralExamQuestionBody,
  headers?: AdvanceOralExamQuestionHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/next-question`,
    advanceOralExamQuestionBody,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getAdvanceOralExamQuestionMutationOptions = <
  TData = Awaited<ReturnType<typeof advanceOralExamQuestion>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: AdvanceOralExamQuestionBody;
      headers?: AdvanceOralExamQuestionHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['advanceOralExamQuestion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof advanceOralExamQuestion>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: AdvanceOralExamQuestionBody;
      headers?: AdvanceOralExamQuestionHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return advanceOralExamQuestion(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: AdvanceOralExamQuestionBody;
      headers?: AdvanceOralExamQuestionHeaders;
    },
    TContext
  >;
};

export type AdvanceOralExamQuestionMutationResult = NonNullable<Awaited<ReturnType<typeof advanceOralExamQuestion>>>;
export type AdvanceOralExamQuestionMutationBody = AdvanceOralExamQuestionBody;
export type AdvanceOralExamQuestionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Advance Oral Exam Question
 */
export const useAdvanceOralExamQuestion = <
  TData = Awaited<ReturnType<typeof advanceOralExamQuestion>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: AdvanceOralExamQuestionBody;
      headers?: AdvanceOralExamQuestionHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: AdvanceOralExamQuestionBody;
    headers?: AdvanceOralExamQuestionHeaders;
  },
  TContext
> => {
  const mutationOptions = getAdvanceOralExamQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Re-stamp the current question answering window (1:1 lecturer conducting).
 * @summary Reset Oral Exam Timer
 */
export const resetOralExamTimer = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  resetOralExamTimerBody: ResetOralExamTimerBody,
  headers?: ResetOralExamTimerHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/reset-timer`,
    resetOralExamTimerBody,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getResetOralExamTimerMutationOptions = <
  TData = Awaited<ReturnType<typeof resetOralExamTimer>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ResetOralExamTimerBody;
      headers?: ResetOralExamTimerHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['resetOralExamTimer'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetOralExamTimer>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ResetOralExamTimerBody;
      headers?: ResetOralExamTimerHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return resetOralExamTimer(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ResetOralExamTimerBody;
      headers?: ResetOralExamTimerHeaders;
    },
    TContext
  >;
};

export type ResetOralExamTimerMutationResult = NonNullable<Awaited<ReturnType<typeof resetOralExamTimer>>>;
export type ResetOralExamTimerMutationBody = ResetOralExamTimerBody;
export type ResetOralExamTimerMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Reset Oral Exam Timer
 */
export const useResetOralExamTimer = <
  TData = Awaited<ReturnType<typeof resetOralExamTimer>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ResetOralExamTimerBody;
      headers?: ResetOralExamTimerHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: ResetOralExamTimerBody;
    headers?: ResetOralExamTimerHeaders;
  },
  TContext
> => {
  const mutationOptions = getResetOralExamTimerMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Re-open the previous question. Driver stays unchanged (1:N drop-in nudge).
 * @summary Repeat Oral Exam Previous Question
 */
export const repeatOralExamPreviousQuestion = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  repeatOralExamPreviousQuestionBody: RepeatOralExamPreviousQuestionBody,
  headers?: RepeatOralExamPreviousQuestionHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/previous-question`,
    repeatOralExamPreviousQuestionBody,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getRepeatOralExamPreviousQuestionMutationOptions = <
  TData = Awaited<ReturnType<typeof repeatOralExamPreviousQuestion>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: RepeatOralExamPreviousQuestionBody;
      headers?: RepeatOralExamPreviousQuestionHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['repeatOralExamPreviousQuestion'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof repeatOralExamPreviousQuestion>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: RepeatOralExamPreviousQuestionBody;
      headers?: RepeatOralExamPreviousQuestionHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return repeatOralExamPreviousQuestion(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: RepeatOralExamPreviousQuestionBody;
      headers?: RepeatOralExamPreviousQuestionHeaders;
    },
    TContext
  >;
};

export type RepeatOralExamPreviousQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof repeatOralExamPreviousQuestion>>
>;
export type RepeatOralExamPreviousQuestionMutationBody = RepeatOralExamPreviousQuestionBody;
export type RepeatOralExamPreviousQuestionMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Repeat Oral Exam Previous Question
 */
export const useRepeatOralExamPreviousQuestion = <
  TData = Awaited<ReturnType<typeof repeatOralExamPreviousQuestion>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: RepeatOralExamPreviousQuestionBody;
      headers?: RepeatOralExamPreviousQuestionHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: RepeatOralExamPreviousQuestionBody;
    headers?: RepeatOralExamPreviousQuestionHeaders;
  },
  TContext
> => {
  const mutationOptions = getRepeatOralExamPreviousQuestionMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Complete the oral exam run.
 * @summary End Oral Exam
 */
export const endOralExam = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: EndOralExamHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/end`, undefined, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getEndOralExamMutationOptions = <
  TData = Awaited<ReturnType<typeof endOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: EndOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['endOralExam'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endOralExam>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: EndOralExamHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return endOralExam(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: EndOralExamHeaders },
    TContext
  >;
};

export type EndOralExamMutationResult = NonNullable<Awaited<ReturnType<typeof endOralExam>>>;

export type EndOralExamMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary End Oral Exam
 */
export const useEndOralExam = <
  TData = Awaited<ReturnType<typeof endOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: EndOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: EndOralExamHeaders },
  TContext
> => {
  const mutationOptions = getEndOralExamMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Complete a 1:1 exam when the other participant is absent on the last question.
 * @summary Complete Oral Exam If Absent
 */
export const completeOralExamIfAbsent = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: CompleteOralExamIfAbsentHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/complete-if-absent`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getCompleteOralExamIfAbsentMutationOptions = <
  TData = Awaited<ReturnType<typeof completeOralExamIfAbsent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CompleteOralExamIfAbsentHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['completeOralExamIfAbsent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeOralExamIfAbsent>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: CompleteOralExamIfAbsentHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return completeOralExamIfAbsent(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CompleteOralExamIfAbsentHeaders;
    },
    TContext
  >;
};

export type CompleteOralExamIfAbsentMutationResult = NonNullable<Awaited<ReturnType<typeof completeOralExamIfAbsent>>>;

export type CompleteOralExamIfAbsentMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Complete Oral Exam If Absent
 */
export const useCompleteOralExamIfAbsent = <
  TData = Awaited<ReturnType<typeof completeOralExamIfAbsent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CompleteOralExamIfAbsentHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: CompleteOralExamIfAbsentHeaders },
  TContext
> => {
  const mutationOptions = getCompleteOralExamIfAbsentMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Abort the oral exam run without cancelling the booking (Slice 6).
 * @summary Abort Oral Exam
 */
export const abortOralExam = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: AbortOralExamHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/abort`, undefined, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getAbortOralExamMutationOptions = <
  TData = Awaited<ReturnType<typeof abortOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: AbortOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['abortOralExam'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof abortOralExam>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: AbortOralExamHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return abortOralExam(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: AbortOralExamHeaders },
    TContext
  >;
};

export type AbortOralExamMutationResult = NonNullable<Awaited<ReturnType<typeof abortOralExam>>>;

export type AbortOralExamMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Abort Oral Exam
 */
export const useAbortOralExam = <
  TData = Awaited<ReturnType<typeof abortOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: AbortOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: AbortOralExamHeaders },
  TContext
> => {
  const mutationOptions = getAbortOralExamMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student intentionally leaves the pre-flight lobby. Non-destructive (the booking is kept) but clears pending consent/ID capture so the lecturer's roster does not stay wedged on a stale 'awaiting photo'. No-op once the exam has started or the ID is approved.
 * @summary Leave Oral Exam Preflight
 */
export const leaveOralExamPreflight = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/leave-preflight`,
    undefined,
    options,
  );
};

export const getLeaveOralExamPreflightMutationOptions = <
  TData = Awaited<ReturnType<typeof leaveOralExamPreflight>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['leaveOralExamPreflight'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof leaveOralExamPreflight>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId } = props ?? {};

    return leaveOralExamPreflight(courseId, moduleId, taskId, bookingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
};

export type LeaveOralExamPreflightMutationResult = NonNullable<Awaited<ReturnType<typeof leaveOralExamPreflight>>>;

export type LeaveOralExamPreflightMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Leave Oral Exam Preflight
 */
export const useLeaveOralExamPreflight = <
  TData = Awaited<ReturnType<typeof leaveOralExamPreflight>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string },
  TContext
> => {
  const mutationOptions = getLeaveOralExamPreflightMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Reset the oral exam run to pre_start with a fresh question draw.
 * @summary Reset Oral Exam
 */
export const resetOralExam = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: ResetOralExamHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/reset`, undefined, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getResetOralExamMutationOptions = <
  TData = Awaited<ReturnType<typeof resetOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: ResetOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['resetOralExam'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetOralExam>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: ResetOralExamHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return resetOralExam(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: ResetOralExamHeaders },
    TContext
  >;
};

export type ResetOralExamMutationResult = NonNullable<Awaited<ReturnType<typeof resetOralExam>>>;

export type ResetOralExamMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Reset Oral Exam
 */
export const useResetOralExam = <
  TData = Awaited<ReturnType<typeof resetOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: ResetOralExamHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: ResetOralExamHeaders },
  TContext
> => {
  const mutationOptions = getResetOralExamMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Pause the exam clock (lecturer-initiated).
 * @summary Pause Oral Exam
 */
export const pauseOralExam = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamPauseRequest: OralExamPauseRequest,
  headers?: PauseOralExamHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/pause`,
    oralExamPauseRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getPauseOralExamMutationOptions = <
  TData = Awaited<ReturnType<typeof pauseOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamPauseRequest;
      headers?: PauseOralExamHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['pauseOralExam'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pauseOralExam>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamPauseRequest;
      headers?: PauseOralExamHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return pauseOralExam(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamPauseRequest;
      headers?: PauseOralExamHeaders;
    },
    TContext
  >;
};

export type PauseOralExamMutationResult = NonNullable<Awaited<ReturnType<typeof pauseOralExam>>>;
export type PauseOralExamMutationBody = OralExamPauseRequest;
export type PauseOralExamMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Pause Oral Exam
 */
export const usePauseOralExam = <
  TData = Awaited<ReturnType<typeof pauseOralExam>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamPauseRequest;
      headers?: PauseOralExamHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: OralExamPauseRequest;
    headers?: PauseOralExamHeaders;
  },
  TContext
> => {
  const mutationOptions = getPauseOralExamMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student signals they are done with the current question.
 * @summary Signal Oral Exam Student Done
 */
export const signalOralExamStudentDone = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  signalOralExamStudentDoneBody: SignalOralExamStudentDoneBody,
  headers?: SignalOralExamStudentDoneHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/student-done`,
    signalOralExamStudentDoneBody,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getSignalOralExamStudentDoneMutationOptions = <
  TData = Awaited<ReturnType<typeof signalOralExamStudentDone>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: SignalOralExamStudentDoneBody;
      headers?: SignalOralExamStudentDoneHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['signalOralExamStudentDone'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signalOralExamStudentDone>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: SignalOralExamStudentDoneBody;
      headers?: SignalOralExamStudentDoneHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return signalOralExamStudentDone(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: SignalOralExamStudentDoneBody;
      headers?: SignalOralExamStudentDoneHeaders;
    },
    TContext
  >;
};

export type SignalOralExamStudentDoneMutationResult = NonNullable<
  Awaited<ReturnType<typeof signalOralExamStudentDone>>
>;
export type SignalOralExamStudentDoneMutationBody = SignalOralExamStudentDoneBody;
export type SignalOralExamStudentDoneMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Signal Oral Exam Student Done
 */
export const useSignalOralExamStudentDone = <
  TData = Awaited<ReturnType<typeof signalOralExamStudentDone>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: SignalOralExamStudentDoneBody;
      headers?: SignalOralExamStudentDoneHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: SignalOralExamStudentDoneBody;
    headers?: SignalOralExamStudentDoneHeaders;
  },
  TContext
> => {
  const mutationOptions = getSignalOralExamStudentDoneMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student signals readiness to begin after the examiner intro handshake. Idempotent and ETag-guarded; requires examiner_ready_at to be set first.
 * @summary Mark Oral Exam Student Ready
 */
export const markOralExamStudentReady = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: MarkOralExamStudentReadyHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/student-ready`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getMarkOralExamStudentReadyMutationOptions = <
  TData = Awaited<ReturnType<typeof markOralExamStudentReady>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamStudentReadyHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['markOralExamStudentReady'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markOralExamStudentReady>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: MarkOralExamStudentReadyHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return markOralExamStudentReady(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamStudentReadyHeaders;
    },
    TContext
  >;
};

export type MarkOralExamStudentReadyMutationResult = NonNullable<Awaited<ReturnType<typeof markOralExamStudentReady>>>;

export type MarkOralExamStudentReadyMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Mark Oral Exam Student Ready
 */
export const useMarkOralExamStudentReady = <
  TData = Awaited<ReturnType<typeof markOralExamStudentReady>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamStudentReadyHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: MarkOralExamStudentReadyHeaders },
  TContext
> => {
  const mutationOptions = getMarkOralExamStudentReadyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student opens the answer window after the examiner has finished reading. Idempotent; stamps answer_started_at so the clock and Done unlock. Used when Cloud Nexus finishes TTS without POSTing answer_window_opened.
 * @summary Open Oral Exam Answer Window
 */
export const openOralExamAnswerWindow = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: OpenOralExamAnswerWindowHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/answer-window`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getOpenOralExamAnswerWindowMutationOptions = <
  TData = Awaited<ReturnType<typeof openOralExamAnswerWindow>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: OpenOralExamAnswerWindowHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['openOralExamAnswerWindow'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof openOralExamAnswerWindow>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: OpenOralExamAnswerWindowHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return openOralExamAnswerWindow(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: OpenOralExamAnswerWindowHeaders;
    },
    TContext
  >;
};

export type OpenOralExamAnswerWindowMutationResult = NonNullable<Awaited<ReturnType<typeof openOralExamAnswerWindow>>>;

export type OpenOralExamAnswerWindowMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Open Oral Exam Answer Window
 */
export const useOpenOralExamAnswerWindow = <
  TData = Awaited<ReturnType<typeof openOralExamAnswerWindow>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: OpenOralExamAnswerWindowHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: OpenOralExamAnswerWindowHeaders },
  TContext
> => {
  const mutationOptions = getOpenOralExamAnswerWindowMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Explicit mutation: complete deferred Track Egress after the student mic appears in the exam room. Idempotent; fail-closes when the mic wait window expires. Not callable from GET/poll paths.
 * @summary Reconcile Oral Exam Deferred Recording
 */
export const reconcileOralExamDeferredRecording = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/reconcile-recording`,
    undefined,
    options,
  );
};

export const getReconcileOralExamDeferredRecordingMutationOptions = <
  TData = Awaited<ReturnType<typeof reconcileOralExamDeferredRecording>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['reconcileOralExamDeferredRecording'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reconcileOralExamDeferredRecording>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId } = props ?? {};

    return reconcileOralExamDeferredRecording(courseId, moduleId, taskId, bookingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
};

export type ReconcileOralExamDeferredRecordingMutationResult = NonNullable<
  Awaited<ReturnType<typeof reconcileOralExamDeferredRecording>>
>;

export type ReconcileOralExamDeferredRecordingMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Reconcile Oral Exam Deferred Recording
 */
export const useReconcileOralExamDeferredRecording = <
  TData = Awaited<ReturnType<typeof reconcileOralExamDeferredRecording>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string },
  TContext
> => {
  const mutationOptions = getReconcileOralExamDeferredRecordingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student reached the lobby waiting room after completing local setup steps. Idempotent and ETag-guarded; gates ready_to_start on the lecturer roster.
 * @summary Mark Oral Exam Preflight Lobby Ready
 */
export const markOralExamPreflightLobbyReady = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: MarkOralExamPreflightLobbyReadyHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/preflight-lobby-ready`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getMarkOralExamPreflightLobbyReadyMutationOptions = <
  TData = Awaited<ReturnType<typeof markOralExamPreflightLobbyReady>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamPreflightLobbyReadyHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['markOralExamPreflightLobbyReady'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markOralExamPreflightLobbyReady>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamPreflightLobbyReadyHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return markOralExamPreflightLobbyReady(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamPreflightLobbyReadyHeaders;
    },
    TContext
  >;
};

export type MarkOralExamPreflightLobbyReadyMutationResult = NonNullable<
  Awaited<ReturnType<typeof markOralExamPreflightLobbyReady>>
>;

export type MarkOralExamPreflightLobbyReadyMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Mark Oral Exam Preflight Lobby Ready
 */
export const useMarkOralExamPreflightLobbyReady = <
  TData = Awaited<ReturnType<typeof markOralExamPreflightLobbyReady>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamPreflightLobbyReadyHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    headers?: MarkOralExamPreflightLobbyReadyHeaders;
  },
  TContext
> => {
  const mutationOptions = getMarkOralExamPreflightLobbyReadyMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student finished or skipped the cohort orientation film in the waiting lounge. Requires approved ID verification. Idempotent and ETag-guarded.
 * @summary Mark Oral Exam Orientation Completed
 */
export const markOralExamOrientationCompleted = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: MarkOralExamOrientationCompletedHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/orientation-completed`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getMarkOralExamOrientationCompletedMutationOptions = <
  TData = Awaited<ReturnType<typeof markOralExamOrientationCompleted>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamOrientationCompletedHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['markOralExamOrientationCompleted'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markOralExamOrientationCompleted>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamOrientationCompletedHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return markOralExamOrientationCompleted(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamOrientationCompletedHeaders;
    },
    TContext
  >;
};

export type MarkOralExamOrientationCompletedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markOralExamOrientationCompleted>>
>;

export type MarkOralExamOrientationCompletedMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Mark Oral Exam Orientation Completed
 */
export const useMarkOralExamOrientationCompleted = <
  TData = Awaited<ReturnType<typeof markOralExamOrientationCompleted>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: MarkOralExamOrientationCompletedHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    headers?: MarkOralExamOrientationCompletedHeaders;
  },
  TContext
> => {
  const mutationOptions = getMarkOralExamOrientationCompletedMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student requests help; pauses the exam clock.
 * @summary Request Oral Exam Help
 */
export const requestOralExamHelp = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: RequestOralExamHelpHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/request-help`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getRequestOralExamHelpMutationOptions = <
  TData = Awaited<ReturnType<typeof requestOralExamHelp>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RequestOralExamHelpHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['requestOralExamHelp'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestOralExamHelp>>,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RequestOralExamHelpHeaders }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return requestOralExamHelp(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RequestOralExamHelpHeaders },
    TContext
  >;
};

export type RequestOralExamHelpMutationResult = NonNullable<Awaited<ReturnType<typeof requestOralExamHelp>>>;

export type RequestOralExamHelpMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Request Oral Exam Help
 */
export const useRequestOralExamHelp = <
  TData = Awaited<ReturnType<typeof requestOralExamHelp>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RequestOralExamHelpHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; headers?: RequestOralExamHelpHeaders },
  TContext
> => {
  const mutationOptions = getRequestOralExamHelpMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Client-reported per-source mute/unpublish; records an integrity outage and pauses.
 * @summary Report Oral Exam Media Disabled
 */
export const reportOralExamMediaDisabled = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  reportOralExamMediaDisabledBody: ReportOralExamMediaDisabledBody,
  headers?: ReportOralExamMediaDisabledHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/report-media-disabled`,
    reportOralExamMediaDisabledBody,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getReportOralExamMediaDisabledMutationOptions = <
  TData = Awaited<ReturnType<typeof reportOralExamMediaDisabled>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaDisabledBody;
      headers?: ReportOralExamMediaDisabledHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['reportOralExamMediaDisabled'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportOralExamMediaDisabled>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaDisabledBody;
      headers?: ReportOralExamMediaDisabledHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return reportOralExamMediaDisabled(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaDisabledBody;
      headers?: ReportOralExamMediaDisabledHeaders;
    },
    TContext
  >;
};

export type ReportOralExamMediaDisabledMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportOralExamMediaDisabled>>
>;
export type ReportOralExamMediaDisabledMutationBody = ReportOralExamMediaDisabledBody;
export type ReportOralExamMediaDisabledMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Report Oral Exam Media Disabled
 */
export const useReportOralExamMediaDisabled = <
  TData = Awaited<ReturnType<typeof reportOralExamMediaDisabled>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaDisabledBody;
      headers?: ReportOralExamMediaDisabledHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: ReportOralExamMediaDisabledBody;
    headers?: ReportOralExamMediaDisabledHeaders;
  },
  TContext
> => {
  const mutationOptions = getReportOralExamMediaDisabledMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Client-reported per-source track re-enable; resumes once integrity is restored.
 * @summary Report Oral Exam Media Enabled
 */
export const reportOralExamMediaEnabled = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  reportOralExamMediaEnabledBody: ReportOralExamMediaEnabledBody,
  headers?: ReportOralExamMediaEnabledHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/report-media-enabled`,
    reportOralExamMediaEnabledBody,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getReportOralExamMediaEnabledMutationOptions = <
  TData = Awaited<ReturnType<typeof reportOralExamMediaEnabled>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaEnabledBody;
      headers?: ReportOralExamMediaEnabledHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['reportOralExamMediaEnabled'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reportOralExamMediaEnabled>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaEnabledBody;
      headers?: ReportOralExamMediaEnabledHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return reportOralExamMediaEnabled(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaEnabledBody;
      headers?: ReportOralExamMediaEnabledHeaders;
    },
    TContext
  >;
};

export type ReportOralExamMediaEnabledMutationResult = NonNullable<
  Awaited<ReturnType<typeof reportOralExamMediaEnabled>>
>;
export type ReportOralExamMediaEnabledMutationBody = ReportOralExamMediaEnabledBody;
export type ReportOralExamMediaEnabledMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Report Oral Exam Media Enabled
 */
export const useReportOralExamMediaEnabled = <
  TData = Awaited<ReturnType<typeof reportOralExamMediaEnabled>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: ReportOralExamMediaEnabledBody;
      headers?: ReportOralExamMediaEnabledHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: ReportOralExamMediaEnabledBody;
    headers?: ReportOralExamMediaEnabledHeaders;
  },
  TContext
> => {
  const mutationOptions = getReportOralExamMediaEnabledMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Transition session_phase (e.g. pre_flight -> in_exam).
 * @summary Transition Oral Exam Session Phase
 */
export const transitionOralExamSessionPhase = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamTransitionPhaseRequest: OralExamTransitionPhaseRequest,
  headers?: TransitionOralExamSessionPhaseHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/transition-session-phase`,
    oralExamTransitionPhaseRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getTransitionOralExamSessionPhaseMutationOptions = <
  TData = Awaited<ReturnType<typeof transitionOralExamSessionPhase>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamTransitionPhaseRequest;
      headers?: TransitionOralExamSessionPhaseHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['transitionOralExamSessionPhase'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transitionOralExamSessionPhase>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamTransitionPhaseRequest;
      headers?: TransitionOralExamSessionPhaseHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return transitionOralExamSessionPhase(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamTransitionPhaseRequest;
      headers?: TransitionOralExamSessionPhaseHeaders;
    },
    TContext
  >;
};

export type TransitionOralExamSessionPhaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof transitionOralExamSessionPhase>>
>;
export type TransitionOralExamSessionPhaseMutationBody = OralExamTransitionPhaseRequest;
export type TransitionOralExamSessionPhaseMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Transition Oral Exam Session Phase
 */
export const useTransitionOralExamSessionPhase = <
  TData = Awaited<ReturnType<typeof transitionOralExamSessionPhase>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamTransitionPhaseRequest;
      headers?: TransitionOralExamSessionPhaseHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: OralExamTransitionPhaseRequest;
    headers?: TransitionOralExamSessionPhaseHeaders;
  },
  TContext
> => {
  const mutationOptions = getTransitionOralExamSessionPhaseMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Record GDPR consent before the in_exam segment.
 * @summary Record Oral Exam Consent
 */
export const recordOralExamConsent = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamRecordConsentRequest: OralExamRecordConsentRequest,
  headers?: RecordOralExamConsentHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/record-consent`,
    oralExamRecordConsentRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getRecordOralExamConsentMutationOptions = <
  TData = Awaited<ReturnType<typeof recordOralExamConsent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRecordConsentRequest;
      headers?: RecordOralExamConsentHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['recordOralExamConsent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordOralExamConsent>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRecordConsentRequest;
      headers?: RecordOralExamConsentHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return recordOralExamConsent(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRecordConsentRequest;
      headers?: RecordOralExamConsentHeaders;
    },
    TContext
  >;
};

export type RecordOralExamConsentMutationResult = NonNullable<Awaited<ReturnType<typeof recordOralExamConsent>>>;
export type RecordOralExamConsentMutationBody = OralExamRecordConsentRequest;
export type RecordOralExamConsentMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Record Oral Exam Consent
 */
export const useRecordOralExamConsent = <
  TData = Awaited<ReturnType<typeof recordOralExamConsent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRecordConsentRequest;
      headers?: RecordOralExamConsentHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: OralExamRecordConsentRequest;
    headers?: RecordOralExamConsentHeaders;
  },
  TContext
> => {
  const mutationOptions = getRecordOralExamConsentMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Record affirmative exam code-of-conduct acknowledgement during pre-flight.
 * @summary Acknowledge Oral Exam Conduct
 */
export const acknowledgeOralExamConduct = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamAcknowledgeConductRequest: OralExamAcknowledgeConductRequest,
  headers?: AcknowledgeOralExamConductHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/acknowledge-conduct`,
    oralExamAcknowledgeConductRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getAcknowledgeOralExamConductMutationOptions = <
  TData = Awaited<ReturnType<typeof acknowledgeOralExamConduct>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamAcknowledgeConductRequest;
      headers?: AcknowledgeOralExamConductHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['acknowledgeOralExamConduct'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acknowledgeOralExamConduct>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamAcknowledgeConductRequest;
      headers?: AcknowledgeOralExamConductHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return acknowledgeOralExamConduct(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamAcknowledgeConductRequest;
      headers?: AcknowledgeOralExamConductHeaders;
    },
    TContext
  >;
};

export type AcknowledgeOralExamConductMutationResult = NonNullable<
  Awaited<ReturnType<typeof acknowledgeOralExamConduct>>
>;
export type AcknowledgeOralExamConductMutationBody = OralExamAcknowledgeConductRequest;
export type AcknowledgeOralExamConductMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Acknowledge Oral Exam Conduct
 */
export const useAcknowledgeOralExamConduct = <
  TData = Awaited<ReturnType<typeof acknowledgeOralExamConduct>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamAcknowledgeConductRequest;
      headers?: AcknowledgeOralExamConductHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: OralExamAcknowledgeConductRequest;
    headers?: AcknowledgeOralExamConductHeaders;
  },
  TContext
> => {
  const mutationOptions = getAcknowledgeOralExamConductMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Submit document and face identity photos in one atomic preflight write.
 * @summary Submit Oral Exam Identity Photos
 */
export const submitOralExamIdentityPhotos = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamSubmitIdentityPhotosRequest: OralExamSubmitIdentityPhotosRequest,
  headers?: SubmitOralExamIdentityPhotosHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/submit-identity-photos`,
    oralExamSubmitIdentityPhotosRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getSubmitOralExamIdentityPhotosMutationOptions = <
  TData = Awaited<ReturnType<typeof submitOralExamIdentityPhotos>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamSubmitIdentityPhotosRequest;
      headers?: SubmitOralExamIdentityPhotosHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['submitOralExamIdentityPhotos'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitOralExamIdentityPhotos>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamSubmitIdentityPhotosRequest;
      headers?: SubmitOralExamIdentityPhotosHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return submitOralExamIdentityPhotos(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamSubmitIdentityPhotosRequest;
      headers?: SubmitOralExamIdentityPhotosHeaders;
    },
    TContext
  >;
};

export type SubmitOralExamIdentityPhotosMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitOralExamIdentityPhotos>>
>;
export type SubmitOralExamIdentityPhotosMutationBody = OralExamSubmitIdentityPhotosRequest;
export type SubmitOralExamIdentityPhotosMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Submit Oral Exam Identity Photos
 */
export const useSubmitOralExamIdentityPhotos = <
  TData = Awaited<ReturnType<typeof submitOralExamIdentityPhotos>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamSubmitIdentityPhotosRequest;
      headers?: SubmitOralExamIdentityPhotosHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: OralExamSubmitIdentityPhotosRequest;
    headers?: SubmitOralExamIdentityPhotosHeaders;
  },
  TContext
> => {
  const mutationOptions = getSubmitOralExamIdentityPhotosMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Upload a lecturer supervisor presence photo captured at briefing entry.
 * @summary Upload Oral Exam Supervisor Photo
 */
export const uploadOralExamSupervisorPhoto = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamUploadSupervisorPhotoRequest: OralExamUploadSupervisorPhotoRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/upload-supervisor-photo`,
    oralExamUploadSupervisorPhotoRequest,
    options,
  );
};

export const getUploadOralExamSupervisorPhotoMutationOptions = <
  TData = Awaited<ReturnType<typeof uploadOralExamSupervisorPhoto>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamUploadSupervisorPhotoRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['uploadOralExamSupervisorPhoto'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadOralExamSupervisorPhoto>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamUploadSupervisorPhotoRequest;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data } = props ?? {};

    return uploadOralExamSupervisorPhoto(courseId, moduleId, taskId, bookingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamUploadSupervisorPhotoRequest;
    },
    TContext
  >;
};

export type UploadOralExamSupervisorPhotoMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadOralExamSupervisorPhoto>>
>;
export type UploadOralExamSupervisorPhotoMutationBody = OralExamUploadSupervisorPhotoRequest;
export type UploadOralExamSupervisorPhotoMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Upload Oral Exam Supervisor Photo
 */
export const useUploadOralExamSupervisorPhoto = <
  TData = Awaited<ReturnType<typeof uploadOralExamSupervisorPhoto>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamUploadSupervisorPhotoRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; taskId: string; bookingId: string; data: OralExamUploadSupervisorPhotoRequest },
  TContext
> => {
  const mutationOptions = getUploadOralExamSupervisorPhotoMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Approve a student's submitted ID verification during pre-flight.
 * @summary Approve Oral Exam Id Verification
 */
export const approveOralExamIdVerification = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: ApproveOralExamIdVerificationHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/approve-id-verification`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getApproveOralExamIdVerificationMutationOptions = <
  TData = Awaited<ReturnType<typeof approveOralExamIdVerification>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: ApproveOralExamIdVerificationHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['approveOralExamIdVerification'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveOralExamIdVerification>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: ApproveOralExamIdVerificationHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return approveOralExamIdVerification(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: ApproveOralExamIdVerificationHeaders;
    },
    TContext
  >;
};

export type ApproveOralExamIdVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveOralExamIdVerification>>
>;

export type ApproveOralExamIdVerificationMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Approve Oral Exam Id Verification
 */
export const useApproveOralExamIdVerification = <
  TData = Awaited<ReturnType<typeof approveOralExamIdVerification>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: ApproveOralExamIdVerificationHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    headers?: ApproveOralExamIdVerificationHeaders;
  },
  TContext
> => {
  const mutationOptions = getApproveOralExamIdVerificationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Reject a student's submitted ID verification during pre-flight.
 * @summary Reject Oral Exam Id Verification
 */
export const rejectOralExamIdVerification = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  oralExamRejectIdVerificationRequest: OralExamRejectIdVerificationRequest,
  headers?: RejectOralExamIdVerificationHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamRunStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/reject-id-verification`,
    oralExamRejectIdVerificationRequest,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getRejectOralExamIdVerificationMutationOptions = <
  TData = Awaited<ReturnType<typeof rejectOralExamIdVerification>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRejectIdVerificationRequest;
      headers?: RejectOralExamIdVerificationHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['rejectOralExamIdVerification'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectOralExamIdVerification>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRejectIdVerificationRequest;
      headers?: RejectOralExamIdVerificationHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, data, headers } = props ?? {};

    return rejectOralExamIdVerification(courseId, moduleId, taskId, bookingId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRejectIdVerificationRequest;
      headers?: RejectOralExamIdVerificationHeaders;
    },
    TContext
  >;
};

export type RejectOralExamIdVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectOralExamIdVerification>>
>;
export type RejectOralExamIdVerificationMutationBody = OralExamRejectIdVerificationRequest;
export type RejectOralExamIdVerificationMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Reject Oral Exam Id Verification
 */
export const useRejectOralExamIdVerification = <
  TData = Awaited<ReturnType<typeof rejectOralExamIdVerification>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      data: OralExamRejectIdVerificationRequest;
      headers?: RejectOralExamIdVerificationHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    data: OralExamRejectIdVerificationRequest;
    headers?: RejectOralExamIdVerificationHeaders;
  },
  TContext
> => {
  const mutationOptions = getRejectOralExamIdVerificationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Return time-slot state and per-booking run summaries for lecturer console polling.
 * @summary Get Oral Exam Time Slot State State
 */
export const getOralExamCohortState = (
  slotId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAggregateTimeSlotStateResponse>> => {
  return axios.get(`/slots/${slotId}/time-slot-state`, options);
};

export const getGetOralExamCohortStateQueryKey = (slotId: string) => {
  return [`/slots/${slotId}/time-slot-state`] as const;
};

export const getGetOralExamCohortStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamCohortState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamCohortStateQueryKey(slotId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamCohortState>>> = ({ signal }) =>
    getOralExamCohortState(slotId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!slotId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOralExamCohortState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOralExamCohortStateQueryResult = NonNullable<Awaited<ReturnType<typeof getOralExamCohortState>>>;
export type GetOralExamCohortStateQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamCohortState<
  TData = Awaited<ReturnType<typeof getOralExamCohortState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamCohortState<
  TData = Awaited<ReturnType<typeof getOralExamCohortState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamCohortState<
  TData = Awaited<ReturnType<typeof getOralExamCohortState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Oral Exam Time Slot State State
 */

export function useGetOralExamCohortState<
  TData = Awaited<ReturnType<typeof getOralExamCohortState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  slotId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamCohortState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamCohortStateQueryOptions(slotId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Open the shared group briefing room for a lecturer-started agent-conducted exam.
 * @summary Open Oral Exam Group Briefing
 */
export const openOralExamGroupBriefing = (
  slotId: string,
  oralExamStartTimeSlotRequest: OralExamStartTimeSlotRequest,
  headers?: OpenOralExamGroupBriefingHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/open-group-briefing`, oralExamStartTimeSlotRequest, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getOpenOralExamGroupBriefingMutationOptions = <
  TData = Awaited<ReturnType<typeof openOralExamGroupBriefing>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: OpenOralExamGroupBriefingHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['openOralExamGroupBriefing'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof openOralExamGroupBriefing>>,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: OpenOralExamGroupBriefingHeaders }
  > = (props) => {
    const { slotId, data, headers } = props ?? {};

    return openOralExamGroupBriefing(slotId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: OpenOralExamGroupBriefingHeaders },
    TContext
  >;
};

export type OpenOralExamGroupBriefingMutationResult = NonNullable<
  Awaited<ReturnType<typeof openOralExamGroupBriefing>>
>;
export type OpenOralExamGroupBriefingMutationBody = OralExamStartTimeSlotRequest;
export type OpenOralExamGroupBriefingMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Open Oral Exam Group Briefing
 */
export const useOpenOralExamGroupBriefing = <
  TData = Awaited<ReturnType<typeof openOralExamGroupBriefing>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: OpenOralExamGroupBriefingHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { slotId: string; data: OralExamStartTimeSlotRequest; headers?: OpenOralExamGroupBriefingHeaders },
  TContext
> => {
  const mutationOptions = getOpenOralExamGroupBriefingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Start the cohort in_exam segment with an explicit admitted booking set.
 * @summary Start Oral Exam Time Slot State
 */
export const startOralExamCohort = (
  slotId: string,
  oralExamStartTimeSlotRequest: OralExamStartTimeSlotRequest,
  headers?: StartOralExamCohortHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/start-time-slot`, oralExamStartTimeSlotRequest, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getStartOralExamCohortMutationOptions = <
  TData = Awaited<ReturnType<typeof startOralExamCohort>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: StartOralExamCohortHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['startOralExamCohort'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startOralExamCohort>>,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: StartOralExamCohortHeaders }
  > = (props) => {
    const { slotId, data, headers } = props ?? {};

    return startOralExamCohort(slotId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: StartOralExamCohortHeaders },
    TContext
  >;
};

export type StartOralExamCohortMutationResult = NonNullable<Awaited<ReturnType<typeof startOralExamCohort>>>;
export type StartOralExamCohortMutationBody = OralExamStartTimeSlotRequest;
export type StartOralExamCohortMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Start Oral Exam Time Slot State
 */
export const useStartOralExamCohort = <
  TData = Awaited<ReturnType<typeof startOralExamCohort>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamStartTimeSlotRequest; headers?: StartOralExamCohortHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { slotId: string; data: OralExamStartTimeSlotRequest; headers?: StartOralExamCohortHeaders },
  TContext
> => {
  const mutationOptions = getStartOralExamCohortMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancel a pre-flight group session when the AI examiner is unavailable.
 * @summary Cancel Oral Exam Technical
 */
export const cancelOralExamTechnical = (
  slotId: string,
  headers?: CancelOralExamTechnicalHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAggregateTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/cancel-technical`, undefined, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getCancelOralExamTechnicalMutationOptions = <
  TData = Awaited<ReturnType<typeof cancelOralExamTechnical>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; headers?: CancelOralExamTechnicalHeaders }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['cancelOralExamTechnical'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelOralExamTechnical>>,
    { slotId: string; headers?: CancelOralExamTechnicalHeaders }
  > = (props) => {
    const { slotId, headers } = props ?? {};

    return cancelOralExamTechnical(slotId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; headers?: CancelOralExamTechnicalHeaders },
    TContext
  >;
};

export type CancelOralExamTechnicalMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOralExamTechnical>>>;

export type CancelOralExamTechnicalMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Cancel Oral Exam Technical
 */
export const useCancelOralExamTechnical = <
  TData = Awaited<ReturnType<typeof cancelOralExamTechnical>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; headers?: CancelOralExamTechnicalHeaders }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string; headers?: CancelOralExamTechnicalHeaders }, TContext> => {
  const mutationOptions = getCancelOralExamTechnicalMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Drop in to a student's exam room or step back to the console.
 * @summary Oral Exam Drop In
 */
export const oralExamDropIn = (
  slotId: string,
  oralExamDropInRequest: OralExamDropInRequest,
  headers?: OralExamDropInHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/drop-in`, oralExamDropInRequest, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getOralExamDropInMutationOptions = <
  TData = Awaited<ReturnType<typeof oralExamDropIn>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamDropInRequest; headers?: OralExamDropInHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['oralExamDropIn'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oralExamDropIn>>,
    { slotId: string; data: OralExamDropInRequest; headers?: OralExamDropInHeaders }
  > = (props) => {
    const { slotId, data, headers } = props ?? {};

    return oralExamDropIn(slotId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamDropInRequest; headers?: OralExamDropInHeaders },
    TContext
  >;
};

export type OralExamDropInMutationResult = NonNullable<Awaited<ReturnType<typeof oralExamDropIn>>>;
export type OralExamDropInMutationBody = OralExamDropInRequest;
export type OralExamDropInMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Oral Exam Drop In
 */
export const useOralExamDropIn = <
  TData = Awaited<ReturnType<typeof oralExamDropIn>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamDropInRequest; headers?: OralExamDropInHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { slotId: string; data: OralExamDropInRequest; headers?: OralExamDropInHeaders },
  TContext
> => {
  const mutationOptions = getOralExamDropInMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Cancel an ambiguous booking and free the slot seat for re-booking.
 * @summary Cancel Oral Exam Booking Allow Rebooking
 */
export const cancelOralExamBookingAllowRebooking = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: CancelOralExamBookingAllowRebookingHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAggregateTimeSlotStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/cancel-and-allow-rebooking`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getCancelOralExamBookingAllowRebookingMutationOptions = <
  TData = Awaited<ReturnType<typeof cancelOralExamBookingAllowRebooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CancelOralExamBookingAllowRebookingHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['cancelOralExamBookingAllowRebooking'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelOralExamBookingAllowRebooking>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CancelOralExamBookingAllowRebookingHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return cancelOralExamBookingAllowRebooking(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CancelOralExamBookingAllowRebookingHeaders;
    },
    TContext
  >;
};

export type CancelOralExamBookingAllowRebookingMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelOralExamBookingAllowRebooking>>
>;

export type CancelOralExamBookingAllowRebookingMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Cancel Oral Exam Booking Allow Rebooking
 */
export const useCancelOralExamBookingAllowRebooking = <
  TData = Awaited<ReturnType<typeof cancelOralExamBookingAllowRebooking>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: CancelOralExamBookingAllowRebookingHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    headers?: CancelOralExamBookingAllowRebookingHeaders;
  },
  TContext
> => {
  const mutationOptions = getCancelOralExamBookingAllowRebookingMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Finalize an ambiguous booking so its oral exam answers enter grading.
 * @summary Submit Oral Exam Booking For Evaluation
 */
export const submitOralExamBookingForEvaluation = (
  courseId: string,
  moduleId: string,
  taskId: string,
  bookingId: string,
  headers?: SubmitOralExamBookingForEvaluationHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAggregateTimeSlotStateResponse>> => {
  return axios.post(
    `/courses/${courseId}/modules/${moduleId}/tasks/${taskId}/bookings/${bookingId}/submit-for-evaluation`,
    undefined,
    {
      ...options,
      headers: { ...headers, ...options?.headers },
    },
  );
};

export const getSubmitOralExamBookingForEvaluationMutationOptions = <
  TData = Awaited<ReturnType<typeof submitOralExamBookingForEvaluation>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: SubmitOralExamBookingForEvaluationHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['submitOralExamBookingForEvaluation'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitOralExamBookingForEvaluation>>,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: SubmitOralExamBookingForEvaluationHeaders;
    }
  > = (props) => {
    const { courseId, moduleId, taskId, bookingId, headers } = props ?? {};

    return submitOralExamBookingForEvaluation(courseId, moduleId, taskId, bookingId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: SubmitOralExamBookingForEvaluationHeaders;
    },
    TContext
  >;
};

export type SubmitOralExamBookingForEvaluationMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitOralExamBookingForEvaluation>>
>;

export type SubmitOralExamBookingForEvaluationMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Submit Oral Exam Booking For Evaluation
 */
export const useSubmitOralExamBookingForEvaluation = <
  TData = Awaited<ReturnType<typeof submitOralExamBookingForEvaluation>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    {
      courseId: string;
      moduleId: string;
      taskId: string;
      bookingId: string;
      headers?: SubmitOralExamBookingForEvaluationHeaders;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  {
    courseId: string;
    moduleId: string;
    taskId: string;
    bookingId: string;
    headers?: SubmitOralExamBookingForEvaluationHeaders;
  },
  TContext
> => {
  const mutationOptions = getSubmitOralExamBookingForEvaluationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Transition the cohort to post_exam phase (lecturer ends the session).
 * @summary Close Oral Exam Time Slot State
 */
export const closeOralExamCohort = (
  slotId: string,
  closeOralExamCohortBody: CloseOralExamCohortBody,
  headers?: CloseOralExamCohortHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/close-time-slot`, closeOralExamCohortBody, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getCloseOralExamCohortMutationOptions = <
  TData = Awaited<ReturnType<typeof closeOralExamCohort>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: CloseOralExamCohortBody; headers?: CloseOralExamCohortHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['closeOralExamCohort'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeOralExamCohort>>,
    { slotId: string; data: CloseOralExamCohortBody; headers?: CloseOralExamCohortHeaders }
  > = (props) => {
    const { slotId, data, headers } = props ?? {};

    return closeOralExamCohort(slotId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: CloseOralExamCohortBody; headers?: CloseOralExamCohortHeaders },
    TContext
  >;
};

export type CloseOralExamCohortMutationResult = NonNullable<Awaited<ReturnType<typeof closeOralExamCohort>>>;
export type CloseOralExamCohortMutationBody = CloseOralExamCohortBody;
export type CloseOralExamCohortMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Close Oral Exam Time Slot State
 */
export const useCloseOralExamCohort = <
  TData = Awaited<ReturnType<typeof closeOralExamCohort>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: CloseOralExamCohortBody; headers?: CloseOralExamCohortHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { slotId: string; data: CloseOralExamCohortBody; headers?: CloseOralExamCohortHeaders },
  TContext
> => {
  const mutationOptions = getCloseOralExamCohortMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Stamp post-exam ended and release the room when wrap-up is dismissed.
 * @summary Close Oral Exam Wrap Up State
 */
export const closeOralExamWrapUp = (
  slotId: string,
  headers?: CloseOralExamWrapUpHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/close-wrap-up`, undefined, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getCloseOralExamWrapUpMutationOptions = <
  TData = Awaited<ReturnType<typeof closeOralExamWrapUp>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; headers?: CloseOralExamWrapUpHeaders }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['closeOralExamWrapUp'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof closeOralExamWrapUp>>,
    { slotId: string; headers?: CloseOralExamWrapUpHeaders }
  > = (props) => {
    const { slotId, headers } = props ?? {};

    return closeOralExamWrapUp(slotId, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; headers?: CloseOralExamWrapUpHeaders },
    TContext
  >;
};

export type CloseOralExamWrapUpMutationResult = NonNullable<Awaited<ReturnType<typeof closeOralExamWrapUp>>>;

export type CloseOralExamWrapUpMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Close Oral Exam Wrap Up State
 */
export const useCloseOralExamWrapUp = <
  TData = Awaited<ReturnType<typeof closeOralExamWrapUp>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { slotId: string; headers?: CloseOralExamWrapUpHeaders }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { slotId: string; headers?: CloseOralExamWrapUpHeaders }, TContext> => {
  const mutationOptions = getCloseOralExamWrapUpMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Broadcast a supervisor message to the whole 1:N cohort (latest-wins).
 * @summary Broadcast Oral Exam Time Slot State Message
 */
export const broadcastOralExamCohortMessage = (
  slotId: string,
  oralExamBroadcastMessageRequest: OralExamBroadcastMessageRequest,
  headers?: BroadcastOralExamCohortMessageHeaders,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAggregateTimeSlotStateResponse>> => {
  return axios.post(`/slots/${slotId}/broadcast-message`, oralExamBroadcastMessageRequest, {
    ...options,
    headers: { ...headers, ...options?.headers },
  });
};

export const getBroadcastOralExamCohortMessageMutationOptions = <
  TData = Awaited<ReturnType<typeof broadcastOralExamCohortMessage>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamBroadcastMessageRequest; headers?: BroadcastOralExamCohortMessageHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['broadcastOralExamCohortMessage'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof broadcastOralExamCohortMessage>>,
    { slotId: string; data: OralExamBroadcastMessageRequest; headers?: BroadcastOralExamCohortMessageHeaders }
  > = (props) => {
    const { slotId, data, headers } = props ?? {};

    return broadcastOralExamCohortMessage(slotId, data, headers, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamBroadcastMessageRequest; headers?: BroadcastOralExamCohortMessageHeaders },
    TContext
  >;
};

export type BroadcastOralExamCohortMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof broadcastOralExamCohortMessage>>
>;
export type BroadcastOralExamCohortMessageMutationBody = OralExamBroadcastMessageRequest;
export type BroadcastOralExamCohortMessageMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Broadcast Oral Exam Time Slot State Message
 */
export const useBroadcastOralExamCohortMessage = <
  TData = Awaited<ReturnType<typeof broadcastOralExamCohortMessage>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { slotId: string; data: OralExamBroadcastMessageRequest; headers?: BroadcastOralExamCohortMessageHeaders },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { slotId: string; data: OralExamBroadcastMessageRequest; headers?: BroadcastOralExamCohortMessageHeaders },
  TContext
> => {
  const mutationOptions = getBroadcastOralExamCohortMessageMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Out-of-band failover signal from the deployed Nexus examiner agent. Machine-authenticated via the shared FLARE_AGENT_SERVICE_TOKEN (Bearer); no user session. Records operational_fault=failover_required and opens a protective pause so the supervisor can drop in or abort. Idempotent.
 * @summary Record Oral Exam Agent Failover
 */
export const recordOralExamAgentFailover = (
  bookingId: string,
  oralExamAgentFailoverRequest: OralExamAgentFailoverRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDictStrBool>> => {
  return axios.post(`/oral-exams/bookings/${bookingId}/agent-failover`, oralExamAgentFailoverRequest, options);
};

export const getRecordOralExamAgentFailoverMutationOptions = <
  TData = Awaited<ReturnType<typeof recordOralExamAgentFailover>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { bookingId: string; data: OralExamAgentFailoverRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['recordOralExamAgentFailover'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordOralExamAgentFailover>>,
    { bookingId: string; data: OralExamAgentFailoverRequest }
  > = (props) => {
    const { bookingId, data } = props ?? {};

    return recordOralExamAgentFailover(bookingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { bookingId: string; data: OralExamAgentFailoverRequest },
    TContext
  >;
};

export type RecordOralExamAgentFailoverMutationResult = NonNullable<
  Awaited<ReturnType<typeof recordOralExamAgentFailover>>
>;
export type RecordOralExamAgentFailoverMutationBody = OralExamAgentFailoverRequest;
export type RecordOralExamAgentFailoverMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Record Oral Exam Agent Failover
 */
export const useRecordOralExamAgentFailover = <
  TData = Awaited<ReturnType<typeof recordOralExamAgentFailover>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { bookingId: string; data: OralExamAgentFailoverRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { bookingId: string; data: OralExamAgentFailoverRequest }, TContext> => {
  const mutationOptions = getRecordOralExamAgentFailoverMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Out-of-band marker/advance events from the deployed Nexus examiner agent. Machine-authenticated via the shared FLARE_AGENT_SERVICE_TOKEN (Bearer); no user session. Tenant is resolved from the JSON body `tenantId`.
 * @summary Apply Oral Exam Agent Event
 */
export const applyOralExamAgentEvent = (
  bookingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDict>> => {
  return axios.post(`/oral-exams/bookings/${bookingId}/agent-events`, undefined, options);
};

export const getApplyOralExamAgentEventMutationOptions = <
  TData = Awaited<ReturnType<typeof applyOralExamAgentEvent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { bookingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['applyOralExamAgentEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof applyOralExamAgentEvent>>, { bookingId: string }> = (
    props,
  ) => {
    const { bookingId } = props ?? {};

    return applyOralExamAgentEvent(bookingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { bookingId: string }, TContext>;
};

export type ApplyOralExamAgentEventMutationResult = NonNullable<Awaited<ReturnType<typeof applyOralExamAgentEvent>>>;

export type ApplyOralExamAgentEventMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Apply Oral Exam Agent Event
 */
export const useApplyOralExamAgentEvent = <
  TData = Awaited<ReturnType<typeof applyOralExamAgentEvent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { bookingId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { bookingId: string }, TContext> => {
  const mutationOptions = getApplyOralExamAgentEventMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Session-addressed twin of booking agent-events for reservationless practice and canonical session ids. Same auth and body contract as the booking path.
 * @summary Apply Oral Exam Session Agent Event
 */
export const applyOralExamSessionAgentEvent = (
  sessionId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseDict>> => {
  return axios.post(`/oral-exams/sessions/${sessionId}/agent-events`, undefined, options);
};

export const getApplyOralExamSessionAgentEventMutationOptions = <
  TData = Awaited<ReturnType<typeof applyOralExamSessionAgentEvent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { sessionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['applyOralExamSessionAgentEvent'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyOralExamSessionAgentEvent>>,
    { sessionId: string }
  > = (props) => {
    const { sessionId } = props ?? {};

    return applyOralExamSessionAgentEvent(sessionId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { sessionId: string }, TContext>;
};

export type ApplyOralExamSessionAgentEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyOralExamSessionAgentEvent>>
>;

export type ApplyOralExamSessionAgentEventMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Apply Oral Exam Session Agent Event
 */
export const useApplyOralExamSessionAgentEvent = <
  TData = Awaited<ReturnType<typeof applyOralExamSessionAgentEvent>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { sessionId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { sessionId: string }, TContext> => {
  const mutationOptions = getApplyOralExamSessionAgentEventMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Minimal machine-authenticated control read for the Nexus examiner start handshake. Authenticated via FLARE_AGENT_SERVICE_TOKEN (Bearer); tenant is resolved from the `tenantId` query parameter.
 * @summary Get Oral Exam Agent Control State
 */
export const getOralExamAgentControlState = (
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAgentControlStateResponse>> => {
  return axios.get(`/oral-exams/bookings/${bookingId}/agent-control-state`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetOralExamAgentControlStateQueryKey = (
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
) => {
  return [`/oral-exams/bookings/${bookingId}/agent-control-state`, ...(params ? [params] : [])] as const;
};

export const getGetOralExamAgentControlStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamAgentControlStateQueryKey(bookingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamAgentControlState>>> = ({ signal }) =>
    getOralExamAgentControlState(bookingId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!bookingId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOralExamAgentControlState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOralExamAgentControlStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOralExamAgentControlState>>
>;
export type GetOralExamAgentControlStateQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Oral Exam Agent Control State
 */

export function useGetOralExamAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  bookingId: string,
  params: GetOralExamAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamAgentControlState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamAgentControlStateQueryOptions(bookingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Session-addressed twin of booking agent-control-state for reservationless practice and canonical session ids. Same auth contract as the booking path.
 * @summary Get Oral Exam Session Agent Control State
 */
export const getOralExamSessionAgentControlState = (
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseOralExamAgentControlStateResponse>> => {
  return axios.get(`/oral-exams/sessions/${sessionId}/agent-control-state`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetOralExamSessionAgentControlStateQueryKey = (
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
) => {
  return [`/oral-exams/sessions/${sessionId}/agent-control-state`, ...(params ? [params] : [])] as const;
};

export const getGetOralExamSessionAgentControlStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOralExamSessionAgentControlStateQueryKey(sessionId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>> = ({ signal }) =>
    getOralExamSessionAgentControlState(sessionId, params, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!sessionId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOralExamSessionAgentControlStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>
>;
export type GetOralExamSessionAgentControlStateQueryError = AxiosError<void | HTTPValidationError>;

export function useGetOralExamSessionAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamSessionAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetOralExamSessionAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Oral Exam Session Agent Control State
 */

export function useGetOralExamSessionAgentControlState<
  TData = Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  sessionId: string,
  params: GetOralExamSessionAgentControlStateParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getOralExamSessionAgentControlState>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetOralExamSessionAgentControlStateQueryOptions(sessionId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
